import { Components } from '@mui/material';
import { MAIN_COLOR } from '~/theme/constant';

export const dialog: Components = {
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        color: MAIN_COLOR,
        padding: '32px 0 16px 32px',
        fontFamily: 'Spartan',
        fontSize: '16px',
        lineHeight: '150%',
        fontWeight: 700,
        fontStyle: 'normal',
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      root: {
        // Match Ant Design Modal mask (theme token colorBgMask: #000 @ 45% alpha)
        '.MuiBackdrop-root': {
          backgroundColor: 'rgba(0, 0, 0, 0.45)',
        },
      },
    },
  },
};
